<template>
	<div class="inputCell">
		<v-textarea
				v-model="inputValue"
				:rows="inputValue ? 1 : 1"
				auto-grow
				dense
				outlined
				hide-details
				@blur="onBlur"
		/>
	</div>
</template>

<script>
export default {
	name: "InputCell",

	props: {
		item: {
			type: Object,
			default: () => ({})
		},

		line: {
			type: Object,
			default: () => ({})
		}
	},

	data() {
		const initialValue = this.getInitialValue();

		return {
			inputValue: initialValue,
			originalValue: initialValue
		};
	},

	watch: {
		line: {
			handler() {
				this.setInitialValue();
			},
			deep: true
		},

		"item.value"() {
			this.setInitialValue();
		}
	},

	methods: {
		getInitialValue() {
			const field = this.item.value;

			if (
				!field ||
					this.line[field] === null ||
					this.line[field] === undefined
			) {
				return "";
			}

			return this.line[field];
		},

		setInitialValue() {
			const value = this.getInitialValue();

			this.inputValue = value;
			this.originalValue = value;
		},

		onBlur() {
			if (this.inputValue === this.originalValue) {
				return;
			}

			this.$emit("updateModEvent", {
				flag: this.item.value,
				value: this.inputValue,
				line: this.line,
				item: this.item
			});

			this.originalValue = this.inputValue;
		}
	}
};
</script>

<style lang="scss">
.inputCell {
	width: 100%;
	min-width: 340px;
	.v-input__slot {
		min-height: 32px !important;
		input {
			padding: 0;
		}
	}

	::v-deep .v-textarea textarea {
		line-height: 20px;
	}
}
</style>
